// Getting a list out of a cpass response.
//
// The API does not use one envelope. Observed on live staging, all returning
// 200 with data present:
//
//   /v1/telephony/groups     -> { organizationId, count, groups:  [...] }
//   /v1/telephony/directory  -> { organizationId, count, entries: [...] }
//   paged endpoints          -> { data: { content: [...] } }
//   some others              -> a bare array
//
// A reader that knows only one of these fails SILENTLY — it yields an empty
// list, not an error. That is how the outbound target picker shipped offering
// no options at all while the API was returning a ring group and two seats on
// every load. Nothing in the UI, the console or the network tab looked wrong:
// three 200s and an empty dropdown.
//
// So callers name the key they expect, and the common wrappers are tried after
// it. Naming the key is not optional politeness — it is what makes the intent
// reviewable when a fourth shape appears.

/**
 * @param payload the axios response body (`res.data`)
 * @param keys    the endpoint's own list key(s), most specific first
 */
export const listFrom = <T = any>(payload: any, ...keys: string[]): T[] => {
  // One level of {data:…} is unwrapped first, because several endpoints nest
  // their real envelope inside it.
  const d = payload?.data ?? payload;
  if (Array.isArray(d)) return d as T[];
  for (const k of [...keys, 'content', 'data']) {
    if (Array.isArray(d?.[k])) return d[k] as T[];
  }
  return [];
};
